const EPIGRAPH_SRC =
    'https://cdn.jsdelivr.net/npm/@epigraph/ar@2.11.6/dist/epigraph-ar.min.js';
const EPIGRAPH_ID = 'epigraph-ar-script';

let epigraphLoadingPromise: Promise<void> | null = null;

export const loadEpigraphAR = (): Promise<void> => {
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('Cannot load Epigraph AR during SSR'));
    }

    if (customElements.get('epigraph-ar')) {
        return Promise.resolve();
    }

    if (epigraphLoadingPromise) {
        return epigraphLoadingPromise;
    }

    epigraphLoadingPromise = new Promise<void>((resolve, reject) => {
        const existing = document.getElementById(
            EPIGRAPH_ID
        ) as HTMLScriptElement | null;

        if (existing) {
            if (existing.dataset.loaded === 'true') {
                resolve();
                return;
            }

            if (existing.dataset.error === 'true') {
                existing.remove();
                // fall through to create a fresh script
            } else {
                existing.addEventListener('load', () => resolve(), {
                    once: true,
                });
                existing.addEventListener(
                    'error',
                    () =>
                        reject(new Error('Failed to load Epigraph AR script')),
                    { once: true }
                );
                return;
            }
        }

        const script = document.createElement('script');
        script.type = 'module';
        script.src = EPIGRAPH_SRC;
        script.id = EPIGRAPH_ID;
        script.async = true;
        script.crossOrigin = 'anonymous';

        script.addEventListener(
            'load',
            () => {
                script.dataset.loaded = 'true';
                resolve();
            },
            { once: true }
        );

        script.addEventListener(
            'error',
            () => {
                script.dataset.error = 'true';
                script.remove();
                reject(new Error('Failed to load Epigraph AR script'));
            },
            { once: true }
        );

        document.body.appendChild(script);
    }).finally(() => {
        epigraphLoadingPromise = null;
    });

    return epigraphLoadingPromise;
};

export const isEpigraphARAvailable = (): boolean => {
    if (typeof window === 'undefined') return false;
    return customElements.get('epigraph-ar') !== undefined;
};
